/**
 * @Author          : SuXiao xiao.su_ext@novartis.com
 * @Date            : 2024-10-09 18:43:02
 * @LastEditors     : SuXiao xiao.su_ext@novartis.com
 * @LastEditTime    : 2025-03-03 09:35:34
 * @FilePath        : \wecom-front-end-admin-portal\src\router\bonus.routes.ts
 * @Description     : [口袋奖金] 相关路由
 * @
 */
import { Role } from '@/model/schema';

const routes = [
  {
    path: '/paidBonusManagement',
    name: 'paidBonusManagement',
    component: () => import('../views/bonus/paidBonusManagement.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '已发奖金管理',
      titleEn: 'paidBonusManagement'
    }
  },
  {
    path: '/peopleInformation',
    name: 'peopleInformation',
    component: () => import('../views/bonus/peopleInformation.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '人员信息',
      titleEn: 'peopleInformation'
    }
  },
  {
    path: '/organization',
    name: 'organization',
    component: () => import('../views/bonus/organization.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '组织架构',
      titleEn: 'organization'
    }
  },
  {
    path: '/productInformation',
    name: 'productInformation',
    component: () => import('../views/bonus/productInformation.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '产品信息',
      titleEn: 'productInformation'
    }
  },
  {
    path: '/productPrice',
    name: '产品价格表',
    component: () => import('../views/bonus/productPrice.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '产品价格表',
      titleEn: 'productPrice'
    }
  },
  {
    path: '/correspondingPeriod',
    name: '指标&同期销售',
    component: () => import('../views/bonus/correspondingPeriod.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '指标&同期销售',
      titleEn: 'correspondingPeriod'
    }
  },
  {
    path: '/growthBonus',
    name: '增长奖参数',
    component: () => import('../views/bonus/growthBonus.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '增长奖参数',
      titleEn: 'growthBonus'
    }
  },
  {
    path: '/exportLog',
    name: '导入日志列表',
    component: () => import('../views/bonus/exportLog.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '导入日志列表',
      titleEn: 'exportLog'
    }
  },
  {
    path: '/bonusestimate',
    name: '奖金预估报表',
    component: () => import('../views/bonus/bonusestimate.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '奖金预估报表',
      titleEn: 'bonusestimate'
    }
  },
  {
    path: '/dmReportForms',
    name: 'DM奖金预估报表',
    component: () => import('../views/bonus/dmReportForms.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: 'DM奖金预估报表',
      titleEn: 'DmReportForms'
    }
  },
  {
    path: '/rmReportForms',
    name: 'RM奖金预估报表',
    component: () => import('../views/bonus/rmReportForms.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: 'RM奖金预估报表',
      titleEn: 'RmReportForms'
    }
  },
  {
    path: '/adReportForms',
    name: 'AD奖金预估报表',
    component: () => import('../views/bonus/adReportForms.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: 'AD奖金预估报表',
      titleEn: 'ADReportForms'
    }
  },
  {
    path: '/reachpayment',
    name: '达成率&支付比例',
    component: () => import('../views/bonus/reachpayment.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '达成率&支付比例',
      titleEn: 'reachpayment'
    }
  }, {
    path: '/lastyearachievementrate',
    name: '去年全年达成率',
    component: () => import('../views/bonus/lastyearachievementrate.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '去年全年达成率',
      titleEn: 'lastyearachievementrate'
    }
  }, {
    path: '/gearrange',
    name: '档位区间',
    component: () => import('../views/bonus/gearrange.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '档位区间',
      titleEn: 'gearrange'
    }
  },
  {
    path: '/geaconfigurationr',
    name: '档位说明',
    component: () => import('../views/bonus/gearraInfo.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '档位说明',
      titleEn: 'geaconfigurationr'
    }
  },
  {
    path: '/pmconfiguration',
    name: '管理员模拟权限配置',
    component: () => import('../views/bonus/pmconfiguration.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '管理员模拟权限配置',
      titleEn: 'pmconfiguration'
    }
  },
  {
    path: '/achievementawardbase',
    name: '达成奖基数',
    component: () => import('../views/bonus/achievementawardbase.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '达成奖基数',
      titleEn: 'achievementawardbase'
    }
  },
  {
    path: '/rankingrenew',
    name: '奖金排行更新',
    component: () => import('../views/bonus/rankingrenew.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '奖金排行更新',
      titleEn: 'rankingrenew'
    }
  },
  {
    path: '/rankingList',
    name: '非销售奖金排行更新',
    component: () => import('../views/bonus/rankingList.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '非销售奖金排行更新',
      titleEn: 'rankingList'
    }
  },
  {
    path: '/noticesbonus',
    name: '公告提示',
    component: () => import('../views/bonus/noticesbonus.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '公告提示',
      titleEn: 'pmconfiguration'
    }
  },
  {
    path: '/configMsg',
    name: '消息配置',
    component: () => import('../views/bonus/configMsg.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '消息配置',
      titleEn: 'configMsg'
    }
  },
  {
    path: '/adList',
    name: 'AD信息',
    component: () => import('../views/bonus/adList.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: 'AD信息',
      titleEn: 'adList'
    }
  },
  {
    path: '/awardConfig',
    name: '奖项配置',
    component: () => import('../views/bonus/awardConfig.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '奖项配置',
      titleEn: 'awardConfig'
    }
  },

  //
  {
    path: '/productInfoCoefficient',
    name: '特定产品线系数配置',
    component: () => import('../views/bonus/productInfoCoefficient.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN ],
      auth: true,
      title: '特定产品线系数配置',
      titleEn: 'productInfoCoefficient'
    }
  },
  {
    path: '/achievementawardbaseConfig',
    name: '档位品牌指标配置',
    component: () => import('../views/bonus/achievementawardbaseConfig.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '档位品牌指标配置',
      titleEn: 'achievementawardbase'
    }
  },
  {
    path: '/awardManagement',
    name: '奖项管理',
    component: () => import('../views/bonus/awardManagement.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '奖项管理',
      titleEn: 'awardManagement'
    }
  },
  {
    path: '/addAward',
    name: '新增奖项',
    component: () => import('../views/bonus/compoennts/addAward.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '新增奖项',
      titleEn: 'addAward'
    }
  },
  {
    path: '/awardContent',
    name: 'awardContent',
    component: () => import('../views/bonus/awardContent.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '奖项内容管理',
      titleEn: 'awardContent'
    }
  },
  {
    path: '/detailsContent',
    name: 'detailsContent',
    component: () => import('../views/bonus/detailsContent.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '奖项详情内容',
      titleEn: 'detailsContent'
    }
  },
  {
    path: '/detailsNewContent',
    name: 'detailsNewContent',
    component: () => import('../views/bonus/detailsNewContent.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '奖项详情内容',
      titleEn: 'detailsNewContent'
    }
  },
  {
    path: '/addDetailsNewContent',
    name: 'addDetailsNewContent',
    component: () => import('../views/bonus/compoennts/addDetailsNewContent.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '奖项详情内容',
      titleEn: 'addDetailsNewContent'
    }
  },
  {
    path: '/addDetailsContent',
    name: 'addDetailsContent',
    component: () => import('../views/bonus/compoennts/addDetailsContent.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '新增奖项内容',
      titleEn: 'addDetailsContent'
    }
  },
]

export default routes;
